import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Tabs,
  Tab,
  Paper,
  Grid,
  Card,
  CardContent,
  CircularProgress,
  Alert
} from '@mui/material';
import {
  HealthAndSafety as ComplianceIcon,
  Dashboard as DashboardIcon,
  Engineering as EngineeringIcon,
  Build as BuildIcon,
  Inventory as AssetsIcon
} from '@mui/icons-material';
import { useSearchParams } from 'react-router-dom';
import HipaaCuiProgressDashboard from './HipaaCuiProgressDashboard';
import HipaaCuiProductEngineering from './HipaaCuiProductEngineering';
import HipaaCuiEnvironmentBuild from './HipaaCuiEnvironmentBuild';
import HipaaCuiAssets from './HipaaCuiAssets';

const darkGreenColor = "#1D4434";

/**
 * HIPAA/CUI Dashboard component with multiple tabs
 * @returns {JSX.Element} HipaaCuiDashboard component
 */
const HipaaCuiDashboard = () => {
  const [searchParams] = useSearchParams();
  const initialTab = searchParams.get('tab');
  const initialFilter = searchParams.get('filter');
  
  // Map tab names to indices
  const tabMap = {
    'dashboard': 0,
    'product-engineering': 1,
    'environment-build': 2,
    'assets': 3
  };
  
  const [tabValue, setTabValue] = useState(
    initialTab && tabMap[initialTab] !== undefined ? tabMap[initialTab] : 0
  );

  useEffect(() => {
    // Handle tab changes from URL params
    if (initialTab && tabMap[initialTab] !== undefined) {
      setTabValue(tabMap[initialTab]);
    }
  }, [initialTab]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box>
      <Box display="flex" alignItems="center" mb={3}>
        <ComplianceIcon sx={{ mr: 1, color: darkGreenColor, fontSize: 28 }} />
        <Typography variant="h4" gutterBottom>
          HIPAA/CUI Compliance
        </Typography>
      </Box>

      <Paper sx={{ mb: 2 }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab icon={<DashboardIcon />} label="Dashboard" iconPosition="start" />
          <Tab icon={<EngineeringIcon />} label="Product Engineering" iconPosition="start" />
          <Tab icon={<BuildIcon />} label="Environment Build" iconPosition="start" />
          <Tab icon={<AssetsIcon />} label="Assets" iconPosition="start" />
        </Tabs>
      </Paper>

      {tabValue === 0 && <HipaaCuiProgressDashboard onCardClick={handleTabChange} />}
      {tabValue === 1 && <HipaaCuiProductEngineering initialFilter={initialFilter} />}
      {tabValue === 2 && <HipaaCuiEnvironmentBuild />}
      {tabValue === 3 && <HipaaCuiAssets />}
    </Box>
  );
};

export default HipaaCuiDashboard;

